(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("progress-form", [], factory);
	else if(typeof exports === 'object')
		exports["progress-form"] = factory();
	else
		root["progress-form"] = factory();
})(self, () => {
return 